import axios from "@/api/axios";

const API_URL = process.env.VUE_APP_API_HOST;

export function postDocumentsQuantity({ companyId, machineId }) {
  return axios.post(
    `${API_URL}/api/admin/companies/${companyId}/documents-quantity`,
    {
      machine_id: machineId,
    }
  );
}

export function getCompany(companyId) {
  return axios.get(`${API_URL}/api/admin/companies/${companyId}`);
}
